/**
 * @generated SignedSource<<9af00f152e95c02c4df568471f868ee6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MemberRole = "OWNER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type UserInfoPopover_member$data = {
  readonly email: string;
  readonly id: string;
  readonly name: string;
  readonly roles: ReadonlyArray<MemberRole>;
  readonly " $fragmentSpreads": FragmentRefs<"UserAvatar_member">;
  readonly " $fragmentType": "UserInfoPopover_member";
};
export type UserInfoPopover_member$key = {
  readonly " $data"?: UserInfoPopover_member$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserInfoPopover_member">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserInfoPopover_member",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "roles",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserAvatar_member"
    }
  ],
  "type": "Member",
  "abstractKey": null
};

(node as any).hash = "a8ee05d9cc1f4b603921a1d528c144ee";

export default node;
